import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAACommercialInventoryMaster";
const FetchRequestType = "GAACommercialInventoryFetchRequest";

export const GetGladianceCommercialInventory = async (Ref) => {
  let payload = { GAACommercialInventoryRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveGladianceInventory = async (
  ref,
  payload,
  images
) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};

export const GetGladianceInventoryList = async () => {
  let payload = { GAACommercialInventoryRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
 // result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

export const DeleteGladianceInventory = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};